import { Navigate, useParams } from "react-router-dom";
import {
  buildTicketEmailViewPath,
  parseTicketIdFromEmailSegment,
} from "@sd/lib/ticketEmailDeepLink";
import NotFound from "@sd/pages/NotFound";

/** `/sd/ticket/{uuid}` or `/sd/{uuid}` → canonical detail page. */
export default function TicketEmailDeepLinkPage() {
  const { ticketId, ticketUuid } = useParams<{
    ticketId?: string;
    ticketUuid?: string;
  }>();
  const id = parseTicketIdFromEmailSegment(ticketId ?? ticketUuid);
  if (!id) {
    return <NotFound />;
  }
  return <Navigate to={buildTicketEmailViewPath(id)} replace />;
}
